import React from "react";

const OrganizerCircle = (props) => {
  return (
    <div className="grey-box">
      <img className="avatar-trim img-center" src={props.avatar} alt="アバター画像" width="30" />
    </div>
  );
};

export default OrganizerCircle;
